import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';
import { dataAttrs } from 'Helpers/Testing';

export const AccountOpeningV2AccountAgreementStepLayout = ({ navigateToLink }) => {
  const { onSubmit, saving, resource } = useMetaLayoutContext();
  return (
    <FDStack spacing={4} direction="column">
      <FDStack spacing={2} direction="column">
        <MetaControlField attr="title" />
        <MetaControlField attr="description" />
        <MetaControlField attr="esgDisclosure" />
        <MetaLayoutRemainingFields noAccordion />
      </FDStack>
      <FDStack direction="row" justifyContent="center" alignItems="center" spacing={2}>
        <WizardBackButtonRel overrideOnClick={(_, rel) => navigateToLink(rel.link('related'))} resource={resource} />
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          label="Save and continue"
          loading={saving}
          onClick={onSubmit}
        />
      </FDStack>
    </FDStack>
  );
};

AccountOpeningV2AccountAgreementStepLayout.defaultProps = {
};

AccountOpeningV2AccountAgreementStepLayout.propTypes = {
  navigateToLink: PropTypes.func.isRequired,
};
